import { render } from "./AssistantWelcome.vue?vue&type=template&id=67dfc15e&scoped=true"
import script from "./AssistantWelcome.vue?vue&type=script&lang=js"
export * from "./AssistantWelcome.vue?vue&type=script&lang=js"

import "./AssistantWelcome.vue?vue&type=style&index=0&id=67dfc15e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67dfc15e"]])

export default __exports__